import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import colors from "./config/colors";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import ReactQueryProvider from "./providers/ReactQueryProvider";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const theme = createTheme({
  palette: {
    primary: { main: colors.primary },
    secondary: { main: colors.secondary },
  },
});

const root = createRoot(document.getElementById("root"));
root.render(
  <StyledEngineProvider injectFirst>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <HelmetProvider>
          <ReactQueryProvider>
            <App />
            <ToastContainer position="bottom-right" autoClose={3000} />{" "}
            <ReactQueryDevtools />
          </ReactQueryProvider>
        </HelmetProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StyledEngineProvider>
);

reportWebVitals();
